import React,{ useState } from 'react'
import { Link } from 'react-router-dom'
import { Microphone,CloudArrowDown ,Pause, Play} from 'phosphor-react'
import PlayList from './Audio/PlayList';
import Waveform from './Audio/WaveForm';
const tracks = [
    {
      id: 0,
      title: "Brahms: St Anthony Chorale - Theme, Two Pianos Op.56b",
      url:
        "https://www.mfiles.co.uk/mp3-downloads/brahms-st-anthony-chorale-theme-two-pianos.mp3"
    },
    {
      id: 1,
      title: "Franz Schubert's Ständchen - Voice (Clarinet) & Piano",
      url:
        "https://www.mfiles.co.uk/mp3-downloads/franz-schubert-standchen-serenade.mp3"
    }
  ];

function ThreeDAudio() {
    const [IsBrowser, setIsBrowser] = useState(0);
    const [liveRecord,setLiveRecord] = useState(false);
    const [pause, setPause] = useState();
    const [selectedTrack, setSelectedTrack] = useState(tracks[0]);
    const [browse , setBrowse] = useState(false);
    const handleVoice = (id) =>{
        setLiveRecord(true);
        setIsBrowser(id);
    }

const HandlePause = () =>{
    setPause(!pause);
}
const handleBrows = (id) =>{
    setIsBrowser(id);
}
console.log('this is browser section >> ',IsBrowser)
  return (
    <>
      <div className="banner-allpage-sec">
        <ul className="breadcrumb">
            <li><Link to="/face-analyser/">Home</Link></li>
            <li>Volume</li>
            <li>3D Audio</li>
        </ul>
        <div className="banner-content-sec text-center">
            <h1 className="first-head">3D Audio</h1>
            <h3 className="second-head">Enhance the stereo sound by adding a 3D effect to it</h3>
            <br/>            
        </div>
    </div>
    <section style={{textAlign:"center", marginTop:-120, position:"relative"}}>        
        <div className="page-container">
            {(IsBrowser==0)?(
                <>
                    <div style={{border:"#ccc 2px dotted", borderRadius:10, background:"#fff", padding:50, width:"100%", margin:"auto"}}>
                        <div className="chakra-heading" style={{fontSize:20, fontWeight:"bold"}}>Drag and drop a file that you want to make 3D</div>
                        <p className="chakra-text">or</p>
                        <button type="file" onClick={()=>handleBrows(1)} className="button orange opnoriginalResultDiv" style={{fontSize:26, borderRadius:10, padding:"15px 30px"}}>
                            <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" focusable="false" className="chakra-icon css-13otjrl" aria-hidden="true" height="1em" width="1em" style={{width:30 ,height:30, position: "relative", top: 0}} xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M320 367.79h76c55 0 100-29.21 100-83.6s-53-81.47-96-83.6c-8.89-85.06-71-136.8-144-136.8-69 0-113.44 45.79-128 91.2-60 5.7-112 43.88-112 106.4s54 106.4 120 106.4h56"></path><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M320 255.79l-64-64-64 64m64 192.42V207.79"></path></svg>
                            Browse computer
                        </button>
                        <div className="txt-eg">Supported file formats: MP3, WAV, FLAC, OGG. Max file size 50MB.</div>
                        <br />
                        <p className="chakra-text">or</p>
                        <button type="file" className="button green clickForLiveRecord" onClick={()=>handleVoice(2)} style={{fontSize:14, borderRadius:25, display:"inline-flex", alignItems:"center", gap:5}}>
                        <Microphone size={32} />    
                            Live Record                
                        </button>
                    </div>
                </>
            ):''}
            {liveRecord?(
                <>
                    <div className="stepLiveRecord" style={{border: "2px dotted rgb(204, 204, 204)", borderRadius: 10, background:" rgb(255, 255, 255)", padding: 50, width: "100%", margin: "auto"}}>  
                        <div className="waveBox">  
                            <Waveform url={selectedTrack.url} />
                            {/* <PlayList
                                tracks={tracks}
                                selectedTrack={selectedTrack}
                                setSelectedTrack={setSelectedTrack}
                            /> */}
                        </div>
                        <br/><br/>
                        <div className="row">
                            <div className="col-lg-6 text-start">
                            {/* {pause ? 
                                <>
                                <button type="file" className="button green clickForPlay" onClick={HandlePause}>
                                    <Pause size={20} />
                                </button>
                                </>
                                :
                                <> 
                                <button type="file" className="button green clickForPause" onClick={HandlePause}>
                                    <Play size={20} />
                                </button>
                                </>

                                } */}
                            </div>
                            <div className="col-lg-6 text-end">
                                <a href="audio/file_example_MP3_700KB.mp3" type="file" onclick="open" className="button orange" style={{fontSize:22}}>
                                <CloudArrowDown size={20} /> Download
                                </a>    
                            </div>
                        </div>
                    </div>
                </>
            ):""}
            {(IsBrowser ===1)?(
            <>
                <div class="stepThree" style={{border: "2px dotted rgb(204, 204, 204)", borderRadius: 10, background: "rgb(255, 255, 255)", padding: 50, width: "100%", margin: "auto"}}>  
                    <div style={{textAlign:"left"}}>                       
                        <button type="file" class="button clickForOne" style={{padding:"0px 15px 10px"}}>
                            <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" focusable="false" class="chakra-icon css-13otjrl" aria-hidden="true" height="1em" width="1em" style={{width:30, height:30, position: "relative", top: 8}} xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M320 367.79h76c55 0 100-29.21 100-83.6s-53-81.47-96-83.6c-8.89-85.06-71-136.8-144-136.8-69 0-113.44 45.79-128 91.2-60 5.7-112 43.88-112 106.4s54 106.4 120 106.4h56"></path><path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M320 255.79l-64-64-64 64m64 192.42V207.79"></path></svg>
                            Browse computer
                        </button>
                        <p style={{marginTop:5, fontSize:14}}>[song.info] 01 - Veshi.mp3</p>    
                    </div>  
                    <div class="waveBox">
                        <img src="images/play-wave.png" alt="" style={{width:"100%"}}/>
                    </div>
                    <br/><br/>
                    <div class="faBarSec">
                        <div class="row barFrequency" style={{display:"flex", alignItems:"center"}}>
                            <div class="col-lg-2">
                                <div>Frequency</div>
                            </div>
                            <div class="col-lg-7">
                                <div class="barLine">
                                    <input class="" type="range" min="0" max="100" value="20"/>
                                </div>
                            </div>
                            <div class="col-lg-2">
                                <div class="barValueInput"><input type="text" value="0.08" style={{width:"100%"}} class="form-input form-control"/></div>
                            </div>
                        </div>
                        <br/>
                        <div class="row barAmount" style={{display:"flex", alignItems:"center"}}>
                            <div class="col-lg-2">
                                <div>Amount</div>
                            </div>
                            <div class="col-lg-7">
                                <div class="barLine">
                                    <input class="" type="range" min="0" max="100" value="50"/>
                                </div>
                            </div>
                            <div class="col-lg-2">
                                <div class="barValueInput"><input type="text" value="0.08" style={{width:"100%"}} class="form-input form-control"/></div>
                            </div>
                        </div>
                    </div>
                    <br/><br/>
                    <div style={{textAlign:"right"}}>    
                        <button type="file" class="button orange opnoriginalResultDiv clickForFour" style={{padding:"10px 15px 10px", display:"inline-flex", gap:6}}>
                            Submit
                            {/* <svg viewBox="0 0 24 24" style={{width:20}} fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M16.3153 16.6681C15.9247 17.0587 15.9247 17.6918 16.3153 18.0824C16.7058 18.4729 17.339 18.4729 17.7295 18.0824L22.3951 13.4168C23.1761 12.6357 23.1761 11.3694 22.3951 10.5883L17.7266 5.9199C17.3361 5.52938 16.703 5.52938 16.3124 5.91991C15.9219 6.31043 15.9219 6.9436 16.3124 7.33412L19.9785 11.0002L2 11.0002C1.44772 11.0002 1 11.4479 1 12.0002C1 12.5524 1.44772 13.0002 2 13.0002L19.9832 13.0002L16.3153 16.6681Z" fill="#fff"></path> </g></svg> */}
                        </button>
                    </div>
                </div>
            </>):""}          
           
        </div>
       
    </section>
    <div className="page-container logo-maker-page">
            <h2 className="text-center">SMARTER. FASTER. EASIER.</h2>
            <br/><br/><br/>
            <div className="row text-center sfe-sec">
                <div className="col-lg-4">
                    <div className="box">
                        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" focusable="false" className="chakra-icon css-wk6432" height="4em" width="4em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M83 384c-13-33-35-93.37-35-128C48 141.12 149.33 48 256 48s208 93.12 208 208c0 34.63-23 97-35 128"></path><path fill="none" stroke-miterlimit="10" strokeWidth="32" d="M108.39 270.13l-13.69 8h0c-30.23 17.7-31.7 72.41-3.38 122.2s75.87 75.81 106.1 58.12h0l13.69-8a16.16 16.16 0 005.78-21.87L130 276a15.74 15.74 0 00-21.61-5.87zm295.22 0l13.69 8h0c30.23 17.69 31.74 72.4 3.38 122.19s-75.87 75.81-106.1 58.12h0l-13.69-8a16.16 16.16 0 01-5.78-21.87L382 276a15.74 15.74 0 0121.61-5.87z"></path></svg>
                        <h3>Online stereo enhancer</h3>
                        <p>This tool allows you to create a 3D audio version of any song directly in your browser. 3D versions of songs are popular on YouTube and with this tool you can create that 3D effect without having to download any annoying software.</p>   
                    </div>        
                </div>
                <div className="col-lg-4">
                    <div className="box">
                        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" focusable="false" className="chakra-icon css-wk6432" height="4em" width="4em" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-miterlimit="10" strokeWidth="32" d="M256 80a176 176 0 10176 176A176 176 0 00256 80z"></path><path fill="none" strokeLinecap="round" stroke-miterlimit="10" strokeWidth="28" d="M200 202.29s.84-17.5 19.57-32.57C230.68 160.77 244 158.18 256 158c10.93-.14 20.69 1.67 26.53 4.45 10 4.76 29.47 16.38 29.47 41.09 0 26-17 37.81-36.37 50.8S251 281.43 251 296"></path><circle cx="250" cy="348" r="20"></circle></svg>
                        <h3>How is it done?</h3>
                        <p>This tool will add a very small delay to one channel which creates a small but noticeable effect. It creates the illusion that the song is playing live in front of you. This effect is only effective if you're listening with headphones.</p> 
                    </div>          
                </div>
                <div className="col-lg-4">
                    <div className="box">
                        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" focusable="false" className="chakra-icon css-wk6432" height="4em" width="4em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M304 48l112 112-112 112m94.87-112H96m112 304L96 352l112-112m-94 112h302"></path></svg>
                        <h3>Example of usage</h3>
                        <p>Here is a before and after example of a short audio file that has been processed using this tool.</p> 
                    </div>         
                </div>
            </div>
     </div>
    </>
  )
}

export default ThreeDAudio
